import { ErrorWithViolations as e } from "./error-with-violations.mjs";
//#region src/errors/error-with-fields.ts
var t = class extends Error {
	errors;
	constructor(e) {
		super(e.errors.common?.join("")), this.errors = e.errors;
	}
	toErrorWithViolations({ type: t, status: n, title: r, code: i }) {
		return new e({
			type: t,
			status: n,
			title: r,
			detail: this.message,
			violations: this.flattenObjectToViolations(this.errors.fields, i, "")
		});
	}
	flattenObjectToViolations(e, t, n = "") {
		let r = [];
		return typeof e == "string" ? (r.push({
			propertyPath: n,
			message: e,
			code: t
		}), r) : (Array.isArray(e) ? e.length === 1 ? r.push({
			propertyPath: n,
			message: e[0],
			code: t
		}) : e.forEach((e, i) => {
			let a = `${n}[${i}]`;
			r.push(...this.flattenObjectToViolations(e, t, a));
		}) : typeof e == "object" && e && Object.entries(e).forEach(([e, i]) => {
			let a = n ? `${n}.${e}` : e;
			r.push(...this.flattenObjectToViolations(i, t, a));
		}), r);
	}
};
//#endregion
export { t as ErrorWithFields };
